import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=4d56d235&scoped=true"
import script from "./Flags.vue?vue&type=script&lang=js"
export * from "./Flags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56d235",
  null
  
)

export default component.exports